import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { HiddenEyeIcon } from '@zola/zola-ui/src/components/SvgIcons';

import { ThemeContext } from 'components/publicWebsiteV2/context';
import { Container } from './HiddenPageBanner.styles';

const HiddenWebsiteBanner = (): JSX.Element | null => {
  const router = useRouter();
  const { preview_type } = router?.query || {}; // if preview_type exists, hide banner
  const { inPreview, pageDataContext } = useContext(ThemeContext);

  if (preview_type || !pageDataContext?.isHidden || inPreview) return null;

  return (
    <Container>
      <>
        <HiddenEyeIcon />
        &nbsp;
      </>{' '}
      This page is hidden, visible only to you.
    </Container>
  );
};

export default HiddenWebsiteBanner;
